import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { EleveViewFilter } from '@teetsh/app/src/types/eleves';
import { ELEVES_VIEWS_KEY } from '@teetsh/app/src/queries/eleves/views/useElevesViews';

function createEleveViewFilter(props: {
  schoolyearId: string;
  schoolId: string;
  viewId: string;
  filter: EleveViewFilter;
}) {
  const f = props.filter;
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-views/${props.viewId}/filters`;
  return request(requestURL, {
    method: 'POST',
    body: {
      operator: f.operator,
      id: f.id,
      value: f.value,
      columnId: f.columnId,
    },
  });
}

export default function useCreateElevesViewFilter(viewId: string) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (filter: EleveViewFilter) =>
      createEleveViewFilter({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        viewId,
        filter,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
    },
  });
  return mutateAsync;
}
